<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListSale()" isJump />
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      class="parent-table"
      size="mini"
      show-footer
      border="none"
      :showOverflow="false"
      :row-config="{ isCurrent: false, isHover: false }"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 148"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
      :keyboard-config="{ isArrow: true }"
      :footer-method="footerMethod"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <template #header_content>
        <div class="parent-header">
          <div class="flex flex-y-center">
            <div class="flex flex-y-center">
              <el-button type="success" size="mini" @click="itemDeliveryDo()"> 新增 </el-button>
            </div>
            <div class="flex flex-y-center m-l-5">
              <el-form class="flex flex-y-center" @submit.native.prevent="searchListData">
                <el-input
                  style="width: 180px"
                  size="mini"
                  placeholder="请输入客户名称/业务员"
                  v-model="keyword"
                  clearable
                  @clear="searchListData"
                />
                <el-button
                  class="m-l-5"
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="searchListData"
                >
                  搜索
                </el-button>
              </el-form>
              <el-button-group class="m-l-5">
                <el-button
                  :type="filterData.delivery_status === '' ? 'primary' : 'default'"
                  size="mini"
                  icon="el-icon-folder-opened"
                  @click="filterStatus('')"
                >
                  全部({{ totalObj.order_total_count }})
                </el-button>
                <el-button
                  :type="filterData.delivery_status === false ? 'info' : 'default'"
                  size="mini"
                  icon="el-icon-edit-outline"
                  @click="filterStatus(false)"
                >
                  待审核({{ totalObj.order_wait_count }})
                </el-button>
                <el-button
                  :type="filterData.delivery_status === true ? 'success' : 'default'"
                  size="mini"
                  icon="el-icon-document-checked"
                  @click="filterStatus(true)"
                >
                  已审核({{ totalObj.order_pass_count }})
                </el-button>
              </el-button-group>
            </div>
          </div>
        </div>
      </template>
      <template #default_content="{ row, rowIndex }">
        <div class="parent-content">
          <div class="child-header">
            <div class="flex flex-y-center">
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">送货单号：</span>
                <el-link type="primary">{{ row.form_data.delivery_code }}</el-link>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">客户名称：</span>
                <span class="c-gray-deep">{{ row.form_data.customer_name }}</span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">发货日期：</span>
                <span class="c-gray-deep">
                  {{ row.form_data.delivery_date && row.form_data.delivery_date.slice(0, 10) }}
                </span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <span class="c-gray-deep">业务员：</span>
                <span class="c-gray-deep">{{ row.form_data.saler_name }}</span>
              </div>
              <div class="flex flex-y-center m-r-15">
                <el-tag size="mini" :type="row.form_data.delivery_status ? 'success' : 'danger'">
                  {{ row.form_data.delivery_status ? '已审核' : '待审核' }}
                </el-tag>
              </div>
            </div>
            <div class="flex flex-y-center">
              <div v-if="row.form_data.delivery_status" class="flex flex-y-center m-l-15">
                <span class="c-gray-deep">审核人：</span>
                <span class="c-gray-deep">{{ row.form_data.checker_name }}</span>
              </div>
              <div v-if="row.form_data.delivery_status" class="flex flex-y-center m-l-15">
                <span class="c-gray-deep">审核日期：</span>
                <span class="c-gray-deep">
                  {{ row.form_data.checker_date && row.form_data.checker_date.slice(0, 10) }}
                </span>
              </div>
              <div v-if="isAdmin" class="flex flex-y-center m-l-15">
                <span class="c-gray-deep">审核状态：</span>
                <el-switch
                  type="primary"
                  v-model="row.form_data.delivery_status"
                  @change="itemAudit(row)"
                />
              </div>
              <div class="m-l-15">
                <el-button
                  v-if="!row.form_data.delivery_status"
                  type="primary"
                  size="mini"
                  icon="f-s-12 el-icon-edit "
                  plain
                  @click="itemDeliveryDo(row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="!row.form_data.delivery_status"
                  type="danger"
                  size="mini"
                  icon="f-s-12 el-icon-delete"
                  plain
                  @click="itemDelete(row)"
                >
                  删除
                </el-button>
                <el-button
                  v-if="row.form_data.delivery_status"
                  type="default"
                  size="mini"
                  icon="f-s-12 el-icon-printer"
                  plain
                  @click="itemPrint(row)"
                >
                  打印
                </el-button>
              </div>
            </div>
          </div>
          <vxe-grid
            :ref="`refSubTable_${rowIndex}`"
            class="child-table"
            size="mini"
            show-footer
            :row-config="{ isCurrent: false, isHover: false }"
            :columns="subTableColumn"
            :data="row.goods_list"
            :footer-method="subFooterMethod"
          />
        </div>
      </template>

      <template #footer_content>
        <div class="flex">
          <span class="m-r-15 m-l-5">合计</span>
          <span class="m-r-15">
            <span>送货数量：</span>
            <span class="f-bold c-orange">{{ totalObj.all_total_count }}</span>
          </span>
          <span class="m-r-15">
            <span>送货金额：</span>
            <span class="f-bold c-orange">{{ totalObj.all_total_amount }}元</span>
          </span>
        </div>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-开送货单 -->
    <PopupShDo
      v-if="isShowPopupShDo"
      :show.sync="isShowPopupShDo"
      :isAdmin="isAdmin"
      :detail="activeDeliveryDetail"
      @success="searchListData"
    />
  </div>
</template>

<script>
import PopupShDo from '../common/popup-sh-do'
export default {
  components: {
    PopupShDo
  },
  data() {
    return {
      loading: true,
      keyword: '',

      // filter
      filterData: {
        delivery_status: ''
      },
      sortData: {
        delivery_id: 'desc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/checkBill/searchHeard',
      tableData: [],
      tableColumn: [
        {
          title: '表格头部内容',
          slots: { header: 'header_content', default: 'default_content', footer: 'footer_content' }
        }
      ],
      subTableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '品名',
          field: 'goods_name',
          width: 200
        },
        {
          title: '规格',
          field: 'goods_spec',
          width: 200
        },
        {
          title: '单位',
          field: 'goods_unit',
          width: 120
        },
        {
          title: '数量',
          field: 'goods_count',
          width: 120
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          width: 120
        },
        {
          title: '金额(元)',
          field: 'goods_amount',
          width: 120
        },
        {
          title: '备注',
          field: 'goods_remark'
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        all_total_count: '',
        all_total_amount: '',
        order_total_count: '',
        order_wait_count: '',
        order_pass_count: ''
      },

      activeDeliveryDetail: null,
      isShowPopupShDo: false
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 筛选状态
    filterStatus(val) {
      this.filterData.delivery_status = val
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/songHuo2/list',
        data: {
          keyword: this.keyword,
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.all_total_count = res.data.all_total_count
            this.totalObj.all_total_amount = res.data.all_total_amount
            this.totalObj.order_total_count = res.data.order_total_count
            this.totalObj.order_wait_count = res.data.order_wait_count
            this.totalObj.order_pass_count = res.data.order_pass_count
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) return '合计'
        })
      ]
    },
    subFooterMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['goods_count', 'goods_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 获取-当前单选行
    getRadioRecord() {
      return this.$refs.refTable.getRadioRecord()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setRadioRow(params.row) // 选中radio
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowRadio = this.$refs.refTable.isCheckedByRadioRow(row)
        if (isCurrentRowRadio) {
          this.$refs.refTable.clearRadioRow() // 清空radio
        } else {
          this.$refs.refTable.setRadioRow(row) // 选中radio
        }
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-开送货单
    itemDeliveryDo(row) {
      this.activeDeliveryDetail = this.$util.deepCopy(row)
      this.isShowPopupShDo = true
    },
    // 项-编辑
    itemEdit() {
      setTimeout(() => {
        let row = this.getRadioRecord()
        if (row) {
          this.itemEditAction(row.bill_id)
        } else {
          this.itemChoosePrompt()
        }
      }, 100)
    },
    // 项-编辑-执行
    itemEditAction(id) {
      window.open(`/sale/verify/detail?id=${id}`, '_blank')
    },
    // 项-打印
    itemPrint(row) {
      window.open(`/sale/delivery/print?id=${row.form_data.delivery_id}`, '_blank')
    },
    // 项-审核
    itemAudit(row) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo2/changeStatus',
        params: {
          delivery_id: row.form_data.delivery_id,
          delivery_status: row.form_data.delivery_status
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('状态修改成功')
          this.getListData()
        }
      })
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`送货单号：${row.form_data.delivery_code}，是否删除该送货单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.form_data.delivery_id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo2/delete',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('删除成功')
          this.getListData()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
